import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Spinner, Alert, Container, Row, Col } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import Field from '../../../components/Entity/Field'
import ModalPicker from '../../../components/Modals/ModalPicker'
import { ViewManager } from '../../../core/view-manager';
import { Utils } from '../../../core/utils';



export default function DGSH_customer_transport_document({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const navigate = useNavigate();
    const [ddtModalOpen, setDdtModalOpen] = useState(false);
    const [ddtLoading, setDdtLoading] = useState(false);
    const [ddtResult, setDdtResult] = useState({ success: 0, errorCount: 0, errors: [] });
    const [processTitle, setProcessTitle] = useState('Elaborazione');

    useEffect(() => {
    }, []);





    /* NEW VERSION V2 - Backend-based DDT creation */
    async function createDDTV2() {
        setProcessTitle('Creazione DDT singoli');
        setDdtResult({ success: 0, errorCount: 0, errors: [] });
        setDdtModalOpen(true);
        setDdtLoading(true);

        try {
            const body = {
                ids: selectedRows
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_ddt_from_transport_single', body);

            if (response && response.success === 1) {
                setDdtResult({
                    success: response.successCount || 0,
                    errorCount: response.errorCount || 0,
                    errors: response.errors || []
                });
                refreshData();
            } else {
                setDdtResult({
                    success: 0,
                    errorCount: 1,
                    errors: [response?.message || 'Errore nella creazione dei DDT']
                });
                refreshData();
            }
        } catch (e) {
            console.error(e);
            setDdtResult({
                success: 0,
                errorCount: 1,
                errors: ['Errore inatteso durante la creazione dei DDT']
            });
        } finally {
            setDdtLoading(false);
        }
    }

    /* NEW VERSION V2 - Backend-based Invoice creation */
    async function createINVV2() {
        setProcessTitle('Creazione fatture singole');
        setDdtResult({ success: 0, errorCount: 0, errors: [] });
        setDdtModalOpen(true);
        setDdtLoading(true);

        try {
            const body = {
                ids: selectedRows
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_invoices_from_transport_single', body);

            if (response && response.success === 1) {
                setDdtResult({
                    success: response.successCount || 0,
                    errorCount: response.errorCount || 0,
                    errors: response.errors || []
                });
                refreshData();
            } else {
                setDdtResult({
                    success: 0,
                    errorCount: 1,
                    errors: [response?.message || 'Errore nella creazione delle fatture']
                });
                refreshData();
            }
        } catch (e) {
            console.error(e);
            setDdtResult({
                success: 0,
                errorCount: 1,
                errors: ['Errore inatteso durante la creazione delle fatture']
            });
        } finally {
            setDdtLoading(false);
        }
    }


    /* NEW VERSION V2 - Backend-based DDT grouped creation */
    async function createDDTGroupV2() {
        setProcessTitle('Creazione DDT raggruppati');
        setDdtResult({ success: 0, errorCount: 0, errors: [] });
        setDdtModalOpen(true);
        setDdtLoading(true);

        try {
            const body = {
                ids: selectedRows
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_ddt_from_transport_group', body);

            if (response && response.success === 1) {
                setDdtResult({
                    success: response.successCount || 0,
                    errorCount: response.errorCount || 0,
                    errors: response.errors || []
                });
                refreshData();
            } else {
                setDdtResult({
                    success: 0,
                    errorCount: 1,
                    errors: [response?.message || 'Errore nella creazione dei DDT raggruppati']
                });
                refreshData();
            }
        } catch (e) {
            console.error(e);
            setDdtResult({
                success: 0,
                errorCount: 1,
                errors: ['Errore inatteso durante la creazione dei DDT raggruppati']
            });
        } finally {
            setDdtLoading(false);
        }
    }

    /* NEW VERSION V2 - Backend-based Invoice grouped creation */
    async function createINVGroupV2() {
        setProcessTitle('Creazione fatture raggruppate');
        setDdtResult({ success: 0, errorCount: 0, errors: [] });
        setDdtModalOpen(true);
        setDdtLoading(true);

        try {
            const body = {
                ids: selectedRows
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_invoices_from_transport_group', body);

            if (response && response.success === 1) {
                setDdtResult({
                    success: response.successCount || 1,
                    errorCount: response.errorCount || 0,
                    errors: response.errors || []
                });
                refreshData();
            } else {
                setDdtResult({
                    success: 0,
                    errorCount: response?.errorCount || 1,
                    errors: response?.errors || [response?.message || 'Errore nella creazione delle fatture raggruppate']
                });
                refreshData();
            }
        } catch (e) {
            console.error(e);
            setDdtResult({
                success: 0,
                errorCount: 1,
                errors: ['Errore inatteso durante la creazione delle fatture raggruppate']
            });
        } finally {
            setDdtLoading(false);
        }
    }


    async function createINVAutomatic() {
        if (!selectedRows || selectedRows.length === 0) {
            toast.warning('Seleziona almeno un documento.', { theme: 'colored' });
            return;
        }
        try {
            const body = {
                ids: selectedRows.toString()
            };
            const res = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_invoices_from_transport', body);
            if (res && res.success === 1) {
                toast.success('Test fatture eseguito con successo.', { theme: 'colored' });
            } else {
                toast.error(`Errore test fatture: ${res && (res.message || res.error_code) ? (res.message || res.error_code) : 'errore sconosciuto'}`, { theme: 'colored' });
            }
        } catch (e) {
            console.error(e);
            toast.error('Errore inatteso durante il test fatture.', { theme: 'colored' });
        }
    }
    async function createDDTAutomatic() {
        if (!selectedRows || selectedRows.length === 0) {
            toast.warning('Seleziona almeno un documento.', { theme: 'colored' });
            return;
        }
        try {
            const body = {
                ids: selectedRows.toString()
            };
            const res = await ApiManager.sendAuthenticatedRequest('/custom/generate_customer_ddt_from_transport_automatic', body);
            if (res && res.success === 1) {
                toast.success('Test DDT eseguito con successo.', { theme: 'colored' });
            } else {
                toast.error(`Errore test DDT: ${res && (res.message || res.error_code) ? (res.message || res.error_code) : 'errore sconosciuto'}`, { theme: 'colored' });
            }
        } catch (e) {
            console.error(e);
            toast.error('Errore inatteso durante il test DDT.', { theme: 'colored' });
        }
    }






    // Use createDDTV2 as the active function
    const createDDT = createDDTV2;
    // Use createDDTGroupV2 as the active function
    const createDDTGroup = createDDTGroupV2;
    // Use createINVV2 as the active function
    const createINV = createINVV2;
    // Use createINVGroupV2 as the active function
    const createINVGroup = createINVGroupV2;

    return (
        <>
            <Container>
                <Row>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='success' size='sm' onClick={() => createINV()}>Crea Fatture singole</Button>
                    </Col>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='outline-success' size='sm' onClick={() => createINVGroup()}>Crea Fatture raggruppate</Button>
                    </Col>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='primary' size='sm' onClick={() => createDDT()} >Crea DDT singoli</Button>
                    </Col>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='outline-primary' size='sm' onClick={() => createDDTGroup()}>Crea DDT raggruppati</Button>
                    </Col>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='secondary' size='sm' onClick={createINVAutomatic}>Crea fatture automatico</Button>
                    </Col>
                    <Col md={12} className='p-0 my-1'>
                        <Button className='w-100' variant='outline-secondary' size='sm' onClick={createDDTAutomatic}>Crea DDT automatico</Button>
                    </Col>
                </Row>
            </Container>





            <Modal show={ddtModalOpen} onHide={() => { if (!ddtLoading) setDdtModalOpen(false); }}>
                <Modal.Header closeButton={!ddtLoading}>
                    <Modal.Title>{processTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ddtLoading ? (
                        <div className='text-center p-3'>
                            <Spinner animation='border' variant='primary' />
                            <p className='text-primary mt-2'>Generazione in corso...</p>
                        </div>
                    ) : (
                        <div>
                            <p><strong>Creati con successo:</strong> {ddtResult.success}</p>
                            <p><strong>Errori:</strong> {ddtResult.errorCount}</p>
                            {ddtResult.errorCount > 0 && (
                                <Alert variant='warning'>
                                    {ddtResult.errors.map((m, idx) => (
                                        <div key={idx}>{m}</div>
                                    ))}
                                </Alert>
                            )}
                        </div>
                    )}
                </Modal.Body>
                {!ddtLoading && (
                    <div className='px-3 pb-3'>
                        <Button variant='secondary' onClick={() => setDdtModalOpen(false)}>Chiudi</Button>
                    </div>
                )}
            </Modal>
        </>
    )

};
